import { render, staticRenderFns } from "./OrderNoteNotifications.vue?vue&type=template&id=01d7eff0&"
import script from "./OrderNoteNotifications.vue?vue&type=script&lang=js&"
export * from "./OrderNoteNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports